type Props = {
  title: string;
};

export function InfoPageHero({title}: Props) {
  return (
    <header className="cc-infoPage__hero">
      <div className="cc-infoPage__heroBg" aria-hidden="true">
        <span className="cc-infoPage__heroOrb cc-infoPage__heroOrb--a" />
        <span className="cc-infoPage__heroOrb cc-infoPage__heroOrb--b" />
        <span className="cc-infoPage__heroOrb cc-infoPage__heroOrb--c" />
      </div>
      <div className="cc-infoPage__heroInner">
        <h1 className="cc-infoPage__title">{title}</h1>
      </div>
    </header>
  );
}
